import React from 'react';
import { Col, Row } from '@saucelabs/sl-component-grid';
import { Breadcrumbs } from '@saucelabs/ds-breadcrumbs/lib';

import GridContainer from '../Layout/GridContainer';
import { TwoStepsCheckoutProgress } from './TwoStepsCheckoutProgress';
import { CheckoutDetailsForm } from './CheckoutDetailsForm';
import { ROUTE_PARENT_SECTION } from '../../constants';
import trackEvent, { EVENTS } from '../../tracking';
import { OrderSummaryFromSelection } from './OrderSummary/OrderSummaryFromSelection';

const crumbList = [
  {
    name: 'Subscription and Billing',
    url: `/${ROUTE_PARENT_SECTION}`,
    onClick: () => trackEvent(EVENTS.PLANS_NAVIGATE_BACK, { checkout_step: 'Enter Details' }),
  },
  { name: 'Checkout' },
];

export const CheckoutDetailsStep = ({
  allPlans,
  orderItems,
}) => (
  <>
    <Breadcrumbs list={crumbList} />
    <TwoStepsCheckoutProgress checkoutStep={2} />
    <GridContainer>
      <Row>
        <Col
          lg={9}
        >
          <Row className="mb-2">
            <CheckoutDetailsForm />
          </Row>
        </Col>
        <Col lg={3}>
          <Row>
            <OrderSummaryFromSelection
              allPlans={allPlans}
              orderItems={orderItems}
            />
          </Row>
        </Col>
      </Row>
    </GridContainer>
  </>
);
